import { render, staticRenderFns } from "./DetailGroupInput.vue?vue&type=template&id=15804b9b&"
import script from "./DetailGroupInput.vue?vue&type=script&lang=js&"
export * from "./DetailGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports